import { ClearFiltersProps } from '../slices/filters'

export const getClearFiltersEventLabel = (
  payload: ClearFiltersProps[],
): string => {
  const category = payload[0].category
  const type = payload[0].type

  if (category) {
    return `${category.label} category`
  }
  if (type === 'sort') {
    return 'sort option'
  }
  return 'all'
}
